import { useLayoutEffect, useRef } from "react";

export const useAutoGrowingTextarea = (value: string, maxHeight = 220) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const textarea = ref.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    const nextHeight = Math.min(textarea.scrollHeight, maxHeight);
    textarea.style.height = `${nextHeight}px`;
    textarea.style.overflowY = "auto";
  }, [maxHeight, value]);

  return ref;
};
